import React from 'react';
import { Link } from 'react-router-dom';
import { FiInstagram, FiMail, FiPhone } from 'react-icons/fi';
import './Footer.css';

const Footer = () => (
  <footer className="footer">
    <div className="container">
      <div className="footer__grid">
        <div className="footer__brand">
          <div className="footer__logo">
            <span className="logo-text">STONARI</span>
            <span className="logo-sub">OFFICIAL</span>
          </div>
          <p className="footer__tagline">Crafted for the ones who shine.<br />Premium fashion jewellery, delivered.</p>
          <div className="footer__social">
            <a href="https://instagram.com/stonariofficial" target="_blank" rel="noreferrer" aria-label="Instagram">
              <FiInstagram size={18} />
            </a>
          </div>
        </div>
        <div className="footer__col">
          <h4>Shop</h4>
          <ul>
            <li><Link to="/shop?category=bracelets">Bracelets</Link></li>
            <li><Link to="/shop?category=necklaces">Necklaces</Link></li>
            <li><Link to="/shop?category=rings">Rings</Link></li>
            <li><Link to="/shop?category=hand-chains">Hand Chains</Link></li>
            <li><Link to="/shop?sale=true">Sale</Link></li>
          </ul>
        </div>
        <div className="footer__col">
          <h4>Help</h4>
          <ul>
            <li><Link to="/track">Track Order</Link></li>
            <li><Link to="/account">My Account</Link></li>
            <li><Link to="/contact">Contact Us</Link></li>
            <li><Link to="/policies/shipping">Shipping Policy</Link></li>
            <li><Link to="/policies/returns">Return & Refund</Link></li>
          </ul>
        </div>
        <div className="footer__col">
          <h4>Legal</h4>
          <ul>
            <li><Link to="/policies/privacy">Privacy Policy</Link></li>
            <li><Link to="/policies/terms">Terms & Conditions</Link></li>
            <li><Link to="/policies/shipping">Shipping & Delivery</Link></li>
            <li><Link to="/policies/returns">Cancellation Policy</Link></li>
          </ul>
        </div>
        <div className="footer__col">
          <h4>Contact</h4>
          <ul>
            <li><a href="mailto:stonariofficial@gmail.com"><FiMail size={12} /> stonariofficial@gmail.com</a></li>
            <li><a href="tel:+917828740737"><FiPhone size={12} /> +91 78287 40737</a></li>
          </ul>
        </div>
      </div>
      <div className="footer__bottom">
        <p>&copy; {new Date().getFullYear()} Stonari Official. All rights reserved.</p>
        <p>Made with ♥ in India</p>
      </div>
    </div>
  </footer>
);

export default Footer;
